import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { variantMap, Heading } from '@grandvisionhq/elements';
import { parseHtml, domToReact } from '@grandvisionhq/utils';
import { colorHexMap } from '../Util/color-map.js';

const regHex = /#([a-f0-9]{3}){1,2}\b/i;
const regPresetBg = /black|grey|white/;
const alignmentOpts = [
    'left',
    'right',
    'center'
];
const variantReverseMap = Object.entries(variantMap).reduce((acc, [key, value])=>swcHelpers.objectSpread({}, acc, {
        [value]: key
    })
, {});
const isElement = (domNode)=>'attribs' in domNode
;
const isAlignment = (alignment)=>alignmentOpts.includes(alignment)
;
const getOptions = (textColor)=>{
    return {
        replace: (domNode)=>{
            if (isElement(domNode) && domNode.name in variantReverseMap) {
                var ref;
                let align = 'left';
                if ((ref = domNode.attribs.style) === null || ref === void 0 ? void 0 : ref.includes('text-align')) {
                    const styles = domNode.attribs.style.split(';');
                    const textAlign = styles.find((s)=>s.includes('text-align')
                    );
                    const [_, value] = textAlign ? textAlign.split(':') : [];
                    align = value && isAlignment(value) ? value : 'left';
                }
                return /*#__PURE__*/ React.createElement(Heading, {
                    variant: variantReverseMap[domNode.name],
                    align: align,
                    color: textColor === 'white' ? 'alt' : undefined
                }, domToReact(domNode.children));
            }
            return domNode;
        }
    };
};
const RichTextArea = ({ content , className , textColor ='black' , backgroundColor ='transparent' , fullWidth  })=>{
    const classNames = classnames('rich-text-area', `rich-text-area--text-${textColor}`, {
        'rich-text-area--full-width': fullWidth
    }, className);
    const richTextAreaStyle = {
        backgroundColor: regHex.test(backgroundColor) ? backgroundColor : regPresetBg.test(backgroundColor) ? colorHexMap[backgroundColor] : 'transparent'
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames,
        style: richTextAreaStyle
    }, parseHtml(content, getOptions(textColor)));
};
var RichTextArea$1 = RichTextArea;

export { RichTextArea, RichTextArea$1 as default };
//# sourceMappingURL=RichTextArea.js.map
